import React, { useEffect, useState } from "react";
import { commonService } from "../../services/commonService";
const CountPage: React.FC = () => {
    const [data, setData] = useState<Record<string, any> | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");

    const fetchData = async () => {
  setLoading(true);
  setError("");

  try {
    const response = await commonService.getCount();
    setData(response);
  } catch (err: any) {
    setError(err.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
    fetchData();
}, []);

const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    alert("Copied!");
};

const copyAll = () => {
    if (!data) return;
    const text = Object.entries(data)
        .map(([k, v]) => `${formatKey(k)}: ${v}`)
        .join("\n");
    copyToClipboard(text);
};

if (loading) return <div style={styles.center}>Loading...</div>;
if (error) return <div style={styles.center}>Error: {error}</div>;

return (
    <div style={styles.container}>
        <div style={styles.header}>
            <h2>📊 Counts Dashboard</h2>
            <div>
                <button style={styles.button} onClick={fetchData}>
                    🔄 Refresh
                </button>
                <button style={styles.button} onClick={copyAll}>
                    📋 Copy All
                </button>
            </div>
        </div>

        <div style={styles.grid}>
            {data &&
                Object.entries(data).map(([key, value]) => (
                    <div key={key} style={styles.card}>
                        <div style={styles.cardHeader}>
                            {formatKey(key)}
                        </div>
                        <div style={styles.cardValue}>
                            {String(value)}
                        </div>
                        <button
                            style={styles.copyBtn}
                            onClick={() => copyToClipboard(String(value))}
                        >
                            Copy
                        </button>
                    </div>
                ))}
        </div>
    </div>
);
};

// Format keys nicely
const formatKey = (key: string) => {
    return key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());
};

// 🎨 Styles
const styles: Record<string, React.CSSProperties> = {
    container: {
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        background: "#f5f7fa",
        minHeight: "100vh",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
    },
    button: {
        marginLeft: "10px",
        padding: "8px 12px",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        background: "#4f46e5",
        color: "#fff",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "15px",
    },
    card: {
        background: "#fff",
        borderRadius: "12px",
        padding: "15px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        textAlign: "center",
    },
    cardHeader: {
        fontSize: "14px",
        color: "#666",
        marginBottom: "10px",
    },
    cardValue: {
        fontSize: "22px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    copyBtn: {
        padding: "5px 10px",
        fontSize: "12px",
        borderRadius: "6px",
        border: "none",
        cursor: "pointer",
        background: "#10b981",
        color: "#fff",
    },
    center: {
        textAlign: "center",
        marginTop: "50px",
        fontSize: "18px",
    },
};

export default CountPage;